/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomZoneFilter
 */
export interface CustomZoneFilter {
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof CustomZoneFilter
     */
    caseInsensitive?: { [key: string]: boolean; };
    /**
     * 
     * @type {string}
     * @memberof CustomZoneFilter
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomZoneFilter
     */
    searchText?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomZoneFilter
     */
    status?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CustomZoneFilter
     */
    warehouseId?: string;
}

/**
 * Check if a given object implements the CustomZoneFilter interface.
 */
export function instanceOfCustomZoneFilter(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CustomZoneFilterFromJSON(json: any): CustomZoneFilter {
    return CustomZoneFilterFromJSONTyped(json, false);
}

export function CustomZoneFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomZoneFilter {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'caseInsensitive': !exists(json, 'caseInsensitive') ? undefined : json['caseInsensitive'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'searchText': !exists(json, 'searchText') ? undefined : json['searchText'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'warehouseId': !exists(json, 'warehouseId') ? undefined : json['warehouseId'],
    };
}

export function CustomZoneFilterToJSON(value?: CustomZoneFilter | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'caseInsensitive': value.caseInsensitive,
        'name': value.name,
        'searchText': value.searchText,
        'status': value.status,
        'warehouseId': value.warehouseId,
    };
}

